import { render, staticRenderFns } from "./ListaWhats.vue?vue&type=template&id=2163ad2e&scoped=true&"
import script from "./ListaWhats.vue?vue&type=script&lang=js&"
export * from "./ListaWhats.vue?vue&type=script&lang=js&"
import style0 from "./ListaWhats.vue?vue&type=style&index=0&id=2163ad2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163ad2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VIcon,VList,VListItem,VListItemAction,VListItemTitle})
